import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ProductDetails from '../views/productDetails.vue'
import News from '../views/news.vue'

Vue.use(VueRouter)

const routes = [
  {
    path:'/index',
    component:HomeView,
  },
  {
    path: "/productDetails",
    component: ProductDetails
  },
  {
    path: "/news",
    component: News
  },
  {
    path:'/',
    redirect:'/index'
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
